import React from "react";
import {Divider, Flex, Image, Label} from "@aws-amplify/ui-react";
import {contains, findAllByKeyValue} from "../../commons/Utils/ArrayUtils";
import {
    consumablesRarities,
    gem,
    getLairBossKeyDescription,
    getRuneSetDescription,
    isBossTrophy,
    isConsumable,
    isGem,
    isLairBossKey,
    isLegendaryRune,
    isMagicRune,
    isRareRune,
    isRitualRune,
    isRune,
    isRuneSet,
    isUniqueRune,
    ITEM_NAMES,
    ITEM_SUB_TYPES,
    ITEM_SUB_TYPES_WITHOUT_STATS,
    ITEM_TYPES,
    ITEM_TYPES_WITH_RARITY,
    lairBossKey,
    legendaryRarity,
    magicRarity,
    mythicRarity,
    rareRarity,
    rune,
    runeSet,
    setRarity,
    uniqueRarity
} from "../../commons/enums/D4Enums";
import "./D4ItemCard.css";
import {
    COLOR_BLOODIED,
    COLOR_GRAY,
    COLOR_GREAT_AFFIX,
    COLOR_LAIR_BOSS_KEY,
    COLOR_LEGENDARY,
    COLOR_MAGIC,
    COLOR_MYTHIC,
    COLOR_RARE,
    COLOR_RUNE,
    COLOR_SET,
    COLOR_UNIQUE,
    COLOR_WHITE,
    getColorByRarity
} from "../../commons/enums/ColorEnums";
import KeySymbol from '../../resources/symbols/KeySymbol.png'
import GemSymbol from '../../resources/symbols/GemSymbol.png'
import RuneSetSymbol from '../../resources/symbols/RuneSetSymbol.png'
import SealSymbol from '../../resources/symbols/SealSymbol.png'
import SealLegendarySymbol from '../../resources/symbols/SealLegendarySymbol.png'
import CharmSymbol from '../../resources/symbols/CharmSymbol.png'
import CharmMagicSymbol from '../../resources/symbols/CharmMagicSymbol.png'
import CharmRareSymbol from '../../resources/symbols/CharmRareSymbol.png'
import CharmUniqueSymbol from '../../resources/symbols/CharmUniqueSymbol.png'
import CharmMythicSymbol from '../../resources/symbols/CharmMythicSymbol.png'
import RitualMagicRune from '../../resources/symbols/RitualMagicRune.png'
import InvocationMagicRune from '../../resources/symbols/InvocationMagicRune.png'
import RitualRareRune from '../../resources/symbols/RitualRareRune.png'
import InvocationRareRune from '../../resources/symbols/InvocationRareRune.png'
import RitualLegendaryRune from '../../resources/symbols/RitualLegendaryRune.png'
import InvocationLegendaryRune from '../../resources/symbols/InvocationLegendaryRune.png'
import RitualUniqueRune from '../../resources/symbols/RitualUniqueRune.png'
import InvocationUniqueRune from '../../resources/symbols/InvocationUniqueRune.png'
import RingSymbol from '../../resources/symbols/RingSymbol.png'
import AmuletSymbol from '../../resources/symbols/AmuletSymbol.png'
import ArmorSymbol from '../../resources/symbols/ArmorSymbol.png'
import WeaponSymbol from '../../resources/symbols/WeaponSymbol.png'
import SwordSymbol from '../../resources/symbols/SwordSymbol.png'
import AxeSymbol from '../../resources/symbols/AxeSymbol.png'
import MaceSymbol from '../../resources/symbols/MaceSymbol.png'
import PolearmSymbol from '../../resources/symbols/PolearmSymbol.png'
import FlailSymbol from '../../resources/symbols/FlailSymbol.png'
import ScythSymbol from '../../resources/symbols/ScythSymbol.png'

import BowSymbol from '../../resources/symbols/BowSymbol.png'

import HelmetSymbol from '../../resources/symbols/HelmetSymbol.png'
import ChestSymbol from '../../resources/symbols/ChestSymbol.png'
import GlovesSymbol from '../../resources/symbols/GlovesSymbol.png'
import PantsSymbol from '../../resources/symbols/PantsSymbol.png'
import BootsSymbol from '../../resources/symbols/BootsSymbol.png'

import {getStatNameLabelObjects} from "../../commons/Utils/StatUtils";
import {D4_SET_AFFIXES} from "../../commons/enums/D4SetAffixes";

const titleFontSize = "1.3em";

const legendaryStyle = {color: COLOR_LEGENDARY};
const aspectNumbersStyle = {color: COLOR_MAGIC};
const rangeNumbersStyle = {color: COLOR_GRAY};
const greaterAffixNumberStyle = {color: COLOR_RARE};
const grayStyle = {color: COLOR_GRAY};
const whiteStyle = {color: COLOR_WHITE};
const whiteStyleBigger = {color: COLOR_WHITE, fontSize: "1.3em"};
const greaterAffixStyle = {color: COLOR_GREAT_AFFIX, textShadow: '1px 1px 0 #8B0000, -1px -1px 0 #8B0000, 1px -1px 0 #8B0000, -1px 1px 0 #8B0000'};
const greaterAffixTitleStyle = {fontSize: titleFontSize, color: COLOR_GREAT_AFFIX, textShadow: '1px 1px 0 #8B0000, -1px -1px 0 #8B0000, 1px -1px 0 #8B0000, -1px 1px 0 #8B0000'}

const uniqueStyle = {color: COLOR_UNIQUE};
const mythicStyle = {color: COLOR_MYTHIC};
const setStyle = {color: COLOR_SET}

const lairBossKeyNameStyle = {
    color: COLOR_LAIR_BOSS_KEY,
    fontSize: titleFontSize,
    textTransform: "uppercase"
}

const runeSetItemNameStyle = {
    color: COLOR_MYTHIC,
    fontSize: titleFontSize,
    textTransform: "uppercase"
}

const magicRuneNameStyle = {
    color: COLOR_MAGIC,
    fontSize: titleFontSize,
    textTransform: "uppercase"
}

const rareRuneNameStyle = {
    color: COLOR_RARE,
    fontSize: titleFontSize,
    textTransform: "uppercase"
}

const legendaryRuneNameStyle = {
    color: COLOR_LEGENDARY,
    fontSize: titleFontSize,
    textTransform: "uppercase"
}

const uniqueNameStyle = {
    color: COLOR_UNIQUE,
    fontSize: titleFontSize,
    textTransform: "uppercase"
}

const getNameStyleByRarity = function (rarity) {
    let color = getColorByRarity(rarity, COLOR_GRAY);

    return {
        color: color,
        fontSize: titleFontSize,
        textTransform: "uppercase"
    }
}

const runeItemNameStyle = {
    color: COLOR_RUNE,
    fontSize: titleFontSize,
    textTransform: "uppercase"
}

const normalTextStyle = {
    color: COLOR_GRAY
}

const bloodiedTextStyle = {
    color: COLOR_BLOODIED
}

const getTitleStyle = function (color) {
    return {
        fontSize: titleFontSize,
        textTransform: "uppercase",
        color: color
    }
}

const getTypeStyle = function (color) {
    return {
        fontSize: "0.75em",
        color: color
    }
}

const getTextStyle = function (rarity, isTitle) {
    if (!rarity) {
        return isTitle ? getTitleStyle(COLOR_WHITE) : getTypeStyle(COLOR_WHITE);
    }

    let color = getColorByRarity(rarity, COLOR_WHITE);

    return isTitle ? getTitleStyle(color) : getTypeStyle(color);
}

const getItemTitleDiv = function (title, titleStyle, greaterAffixSize) {
    if (title) {
        if (greaterAffixSize === 0) {
            return <div style={titleStyle}>{title}</div>
        }

        if (greaterAffixSize === 1) {
            return <div>
                <span style={titleStyle}>{title}</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
            </div>
        }

        if (greaterAffixSize === 2) {
            return <div>
                <span style={titleStyle}>{title}</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
            </div>
        }

        if (greaterAffixSize === 3) {
            return <div>
                <span style={titleStyle}>{title}</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
            </div>
        }

        if (greaterAffixSize === 4) {
            return <div>
                <span style={titleStyle}>{title}</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
                <span style={greaterAffixTitleStyle}> &#10039;</span>
            </div>
        }
    }

    return null;
}

const getSymbol = function (type, subType, item, rarity) {
    let name = item.name;
    if (type) {
        if (type === ITEM_TYPES[1]) {
            if(subType === ITEM_SUB_TYPES[type][3]) {
                return BowSymbol;
            }
            if(name === ITEM_NAMES["Two-Handed"][1]) {
                return AxeSymbol;
            }
            if(name === ITEM_NAMES["Two-Handed"][2]) {
                return MaceSymbol;
            }
            if(name === ITEM_NAMES["Two-Handed"][3]) {
                return PolearmSymbol;
            }
            if(name === ITEM_NAMES["Two-Handed"][4]) {
                //TODO: Kampfstab
                return WeaponSymbol;
            }
            if(name === ITEM_NAMES["Two-Handed"][5]) {
                return SwordSymbol;
            }
            if(name === ITEM_NAMES["Two-Handed"][6]) {
                return ScythSymbol;
            }

            if(name === ITEM_NAMES["One-Handed"][8]) {
                return FlailSymbol;
            }

            return WeaponSymbol;
        }
        if (type === ITEM_TYPES[2]) {
            if(subType === ITEM_SUB_TYPES[type][0]) {
                return HelmetSymbol;
            }
            if(subType === ITEM_SUB_TYPES[type][1]) {
                return ChestSymbol;
            }
            if(subType === ITEM_SUB_TYPES[type][2]) {
                return GlovesSymbol;
            }
            if(subType === ITEM_SUB_TYPES[type][3]) {
                return PantsSymbol;
            }
            if(subType === ITEM_SUB_TYPES[type][4]) {
                return BootsSymbol;
            }
            return ArmorSymbol;
        }
        if(subType === ITEM_SUB_TYPES["Jewelry"][0]) {
            return AmuletSymbol;
        }
        if(subType === ITEM_SUB_TYPES["Jewelry"][1]) {
            return RingSymbol;
        }
        if(subType === ITEM_SUB_TYPES["Talisman"][0]) {
            if(rarity === setRarity) {
                //kein set charm Bild passt da sie pro Klasse anders aussehen
                return null;
            }
            if(rarity === magicRarity) {
                return CharmMagicSymbol;
            }
            if(rarity === rareRarity) {
                return CharmRareSymbol;
            }
            if(rarity === uniqueRarity) {
                return CharmUniqueSymbol;
            }
            if(rarity === mythicRarity) {
                return CharmMythicSymbol;
            }

            return CharmSymbol;
        }
        if(subType === ITEM_SUB_TYPES["Talisman"][1]) {
            if(rarity === legendaryRarity) {
                return SealLegendarySymbol;
            }

            return SealSymbol;
        }
        if(subType === gem) {
            return GemSymbol;
        }
        if(subType === rune) {
            if(isMagicRune(item)) {
                if(isRitualRune(item)) {
                    return RitualMagicRune;
                }
                return InvocationMagicRune;
            }
            if(isRareRune(item)) {
                if(isRitualRune(item)) {
                    return RitualRareRune;
                }
                return InvocationRareRune;
            }
            if(isLegendaryRune(item)) {
                if(isRitualRune(item)) {
                    return RitualLegendaryRune;
                }
                return InvocationLegendaryRune;
            }
            if(isUniqueRune(item)) {
                if(isRitualRune(item)) {
                    return RitualUniqueRune;
                }
                return InvocationUniqueRune;
            }

            return null;
        }
        if(subType === runeSet) {
            return RuneSetSymbol;
        }
        if(subType === lairBossKey) {
            return KeySymbol;
        }
    }

    return null;
}

const bloodiedPrefixes = ["Rampage:", "Feast:", "Hunger:"];

const updateStyleForBloodiedLabelObjects=function(labelsObjectsArray) {
    if(!labelsObjectsArray || labelsObjectsArray.length === 0) {
        return;
    }

    const firstObject = labelsObjectsArray[0];

    for (const bloodiedPrefix of bloodiedPrefixes) {
        if (firstObject.labelValue.startsWith(bloodiedPrefix)) {
            firstObject.labelValue = firstObject.labelValue.substring(bloodiedPrefix.length)
            labelsObjectsArray.unshift({labelKey: firstObject.labelKey + " bloodied", labelStyle: bloodiedTextStyle, labelValue: bloodiedPrefix})
            return;
        }
    }
}

function relabelSetAffixes(labelValue) {
    if (typeof labelValue !== "string") {
        return labelValue;
    }

    const escaped = D4_SET_AFFIXES.map(term =>
        term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    );

    const regex = new RegExp(`(${escaped.join("|")})`, "gi");

    return labelValue.split(regex).map((part, index) => {
        const highlight = D4_SET_AFFIXES.find(
            h => h.toLowerCase() === part.toLowerCase()
        );

        if (highlight) {
            return (
                <span
                    key={index}
                    style={setStyle}
                >
                    {part}
                </span>
            );
        }

        return <React.Fragment key={index}>{part}</React.Fragment>;
    });
}

const D4ItemCard = function (props) {
    const {item, maxHeight, amount, isFree} = props;

    React.useEffect(() => {
    }, [item]);

    const isArmor = item.armor && item.armor > 0;
    const isDps = item.dps && item.dps > 0;
    const isAllResist = item.allResist && item.allResist > 0;

    const itemType = item.type ? item.type : item.itemType;
    const itemSubType = item.subType ? item.subType : item.itemSubType;


    const isWithoutStats = contains(ITEM_SUB_TYPES_WITHOUT_STATS, itemSubType);
    const isItemWithRarity = contains(ITEM_TYPES_WITH_RARITY, itemType);
    const itemRarity = item.rarity ? item.rarity : null;

    //TODO: symbol noch ausgeklammert
    const symbol = getSymbol(itemType, itemSubType, item, itemRarity);

    const amountText = amount && amount > 1 ? " (" + amount + ")" : "";

    const titleStyle = getTextStyle(itemRarity, true);
    const typeStyle = getTextStyle(itemRarity, false);
    const isItemLairBossKey = isLairBossKey(item);
    let isCustomItem = false;
    let customItemDescription = [];
    let customItemNameStyle = "";
    if (isItemLairBossKey) {
        isCustomItem = true;
        customItemDescription = getLairBossKeyDescription(item.name);
        customItemNameStyle = lairBossKeyNameStyle;
    }

    if (isRuneSet(item)) {
        isCustomItem = true;
        customItemDescription = getRuneSetDescription(item.name);
        customItemNameStyle = runeSetItemNameStyle;
    }

    if (isRune(item)) {
        isCustomItem = true;

        let runeRarity = itemRarity;
        if(isMagicRune(item)) {
            runeRarity = magicRarity;
        }
        if(isRareRune(item)) {
            runeRarity = rareRarity;
        }
        if(isLegendaryRune(item)) {
            runeRarity = legendaryRarity;
        }
        if(isUniqueRune(item)) {
            runeRarity = uniqueRarity;
        }

        customItemNameStyle = getNameStyleByRarity(runeRarity);
    }

    if (isGem(item)) {
        if(item.name.startsWith("Horadric")) {
            isCustomItem = true;
            customItemNameStyle = getNameStyleByRarity(magicRarity);
        }
    }

    if (isBossTrophy(item)) {
        isCustomItem = true;
        customItemNameStyle = getNameStyleByRarity(rareRarity);
    } else if (isConsumable(item)) {
        isCustomItem = true;
        customItemNameStyle = getNameStyleByRarity(consumablesRarities[item.name]);
    }



    const itemName = isItemWithRarity ? (item.rarity ? item.rarity + " " + item.name : "Normal " + item.name) : item.name;

    // maps a stat to a div with all the needed labels for colors and special signs like ga stars
    const mapStatToDiv = function (stat, divIndex, isAspect, isUniqueAffix, isSet, isMythic) {
        if (isAspect === true || isUniqueAffix === true || isSet === true || isMythic === true) {
            let textStyle;
            if(isAspect === true) {
                textStyle = legendaryStyle;
            } else if(isSet === true) {
                textStyle = setStyle;
            } else if(isMythic === true) {
                textStyle = mythicStyle;
            } else {
                textStyle = uniqueStyle;
            }

            const labelsObjectsArray = getStatNameLabelObjects(divIndex, stat, isAspect, textStyle, aspectNumbersStyle, rangeNumbersStyle)

            return <div key={divIndex}>
                {isAspect === true ?
                    <Label key={divIndex + " label -1"} style={textStyle}>&#9733; </Label> : null
                }

                {isUniqueAffix === true ?
                    <Label key={divIndex + " label -1"} style={textStyle}>&#10037; </Label> : null
                }

                {
                    labelsObjectsArray.map((labelObject) =>
                        <Label key={labelObject.labelKey} style={labelObject.labelStyle}>
                            {relabelSetAffixes(labelObject.labelValue)}
                        </Label>
                    )
                }
            </div>
        } else {
            const textStyle = stat.greaterAffix === true ? whiteStyle : grayStyle;
            const numberStyle = whiteStyle;
            const labelsObjectsArray = getStatNameLabelObjects(divIndex, stat, false, textStyle, numberStyle, rangeNumbersStyle)
            updateStyleForBloodiedLabelObjects(labelsObjectsArray);
            return <div key={divIndex}>
                {
                    stat.greaterAffix === true ?
                        <Label key={divIndex + " label 0"} style={greaterAffixStyle}>&#10039;</Label> :
                        <Label key={divIndex + " label 0"} style={normalTextStyle}>&#x25C6;</Label>
                }
                {
                    labelsObjectsArray.map((labelObject) =>
                        <Label key={labelObject.labelKey} style={labelObject.labelStyle}>
                            {relabelSetAffixes(labelObject.labelValue)}
                        </Label>
                    )
                }
            </div>
        }
    }

    const greaterAffixStats = item.stats ? findAllByKeyValue(item.stats, "greaterAffix", true) : null;
    const greaterAffixSize = item.stats && greaterAffixStats ? greaterAffixStats.length : 0;
    const itemTitleDiv = getItemTitleDiv(item.title, titleStyle, greaterAffixSize);

    const style = maxHeight ? {height: '100%'} : null;

    return (
        <div className="itemcard" style={style}>
            {isFree && <div className="ribbon">FREE</div>}
            <Flex direction={"row"} alignItems="flex-start" justifyContent="space-between">
                <div>
                    {
                        item.title ? itemTitleDiv : null
                    }
                    {
                        isCustomItem ?
                            <Flex direction={"column"} gap={"0rem"}>
                                <Label style={customItemNameStyle}>{itemName + amountText}</Label>
                                <Label style={grayStyle}>{itemSubType}</Label>
                                {
                                    customItemDescription.length > 0 ? <Divider/> : null
                                }
                                {
                                    customItemDescription.map((description, index) => <Label key={index} style={whiteStyle}>{description}</Label>)
                                }
                            </Flex>
                            : [
                                <div key={"amount"} style={item.title ? typeStyle : titleStyle}>{itemName + amountText}</div>,
                                <div key={"itemSubType"} style={typeStyle}>{itemSubType}</div>
                            ]
                    }
                    {
                        item.itemPower > 0 ? <div style={normalTextStyle}>{item.itemPower + " Item Power"}</div> : null
                    }
                </div>
                {symbol !== null ? <Image src={symbol} width="50px" height={"auto"} objectFit={"contain"}></Image> : null}
            </Flex>
            <Divider/>
            {
                isArmor || isDps || isAllResist ?
                    <div>
                        {
                            isArmor ? <Label style={whiteStyleBigger}>{item.armor + " Armor"}</Label> : null
                        }
                        {
                            isDps ? <Label style={whiteStyleBigger}>{item.dps + " Damage Per Second"}</Label> : null
                        }
                        {
                            isAllResist ? <Label style={whiteStyleBigger}>{item.allResist + " All Resist"}</Label> : null
                        }
                    </div> : null
            }
            {
                item.basicStats && item.basicStats.length > 0 ? <div>
                    {
                        item.basicStats.map((stat, index) => mapStatToDiv(stat, index))
                    }
                    <Divider/>
                </div> : null
            }
            {
                isWithoutStats || !item.stats || item.stats.length === 0 ? null :
                    <div>
                        {
                            item.stats.map(mapStatToDiv)
                        }
                    </div>
            }
            {
                isWithoutStats || !item.aspects || item.aspects.length === 0 ? null :
                    <div>
                        {
                            item.aspects.map((stat, index) => mapStatToDiv(stat, index, true))
                        }
                    </div>
            }
            {
                isWithoutStats || !item.uniqueAffixes || item.uniqueAffixes.length === 0 ? null :
                    <div>
                        {
                            item.uniqueAffixes.map((stat, index) => mapStatToDiv(stat, index, false, true))
                        }
                    </div>
            }
            {
                isWithoutStats || !item.setAffixes || item.setAffixes.length === 0 ? null :
                    <div>
                        {
                            item.setAffixes.map((stat, index) => mapStatToDiv(stat, index, false, false, true))
                        }
                    </div>
            }
            {
                isWithoutStats || !item.mythicAffixes || item.mythicAffixes.length === 0 ? null :
                    <div>
                        {
                            item.mythicAffixes.map((stat, index) => mapStatToDiv(stat, index, false, false, false, true))
                        }
                    </div>
            }
            {
                item.levelRequirement > 0 ? <Flex direction={"row"} justifyContent={"flex-end"}><Label style={whiteStyle}>{"Requires Level " + item.levelRequirement}</Label></Flex>
                    : null
            }
            {
                item.classRequirement && item.classRequirement !== "Any" ? <Flex direction={"row"} justifyContent={"flex-end"}>
                    <div style={normalTextStyle}>{item.classRequirement} </div>
                </Flex> : null
            }
        </div>
    );
};
export default D4ItemCard;